import React from 'react';
import CheckBoxAutoComplete from '../../utils/CheckboxesAutoComplete';
import { ReferenceInput } from 'react-admin';
import { ClientDataType, ClientListProps } from '../../utils/DataTypes';
import { FORM_LABELS, MEMBER_SUMMARY_STRINGS } from '../../constants';

const getOptionLabel = (option: ClientDataType) => {
  return `${option.client_name}${
    option.client_number ? ` (${option.client_number})` : ` ${MEMBER_SUMMARY_STRINGS.CLIENT_ID_MISSING_LABEL}`
  }`;
};

const ClientList = ({ setFunction, reset, filter, report_type }: ClientListProps) => {
  return (
    <ReferenceInput
      key={report_type}
      label={FORM_LABELS.CLIENT_NAME}
      source="clientname"
      reference="clients"
      filter={filter}
      sx={{ textTransform: 'capitalize', width: '100%' }}
    >
      <CheckBoxAutoComplete
        setFunction={setFunction}
        label={FORM_LABELS.CLIENTS}
        reset={reset}
        getOptionLabel={getOptionLabel}
        optionValueKey="client_number"
      />
    </ReferenceInput>
  );
};

export default ClientList;
